<template>
  <div>
    <!-- 输入框 -->
    <a-input :type="type" v-model:value="state.phone" @blur="inputEnterBlur" @pressEnter="inputEnterBlur" :placeholder="props.placeholder">
      <template #suffix>
        <a-tooltip :title="props.suffixTitle">
          <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </template>
      <!-- 输入框后缀提示 -->
    </a-input>
    <div>
      <!-- 手机号列表 -->
      <div v-for="(item, index) in state.phoneList" :key="index" class="phone-item">
        <a-row>
          <a-col :span="10">
            <div>{{ item.name }}</div> </a-col
          ><a-col :span="10">
            <div>
              <a-form-item name="默认授权" class="phone-item-margin">
                <a-checkbox v-model:checked="item.default">默认授权</a-checkbox>
              </a-form-item>
            </div>
          </a-col>
          <a-col :span="4">
            <!-- 删除按钮 -->
            <DeleteOutlined style="cursor: pointer" @click="deleteClick(index)" />
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from 'vue'
import { message } from 'ant-design-vue'
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
  value: {
    type: Array
  },
  placeholder: {
    type: String
  },
  suffixTitle: {
    type: String
  },
  inputType: {
    type: String
  },
  type: {
    type: String,
    default: 'text'
  }
})
interface state {
  phone: string
  phoneList: { name: string; default: boolean }[]
}
const state = reactive<state>({
  phone: '',
  phoneList: []
})
watch(
  () => props.value,
  (val) => {
    if (val && val.length > 0) {
      state.phoneList = val as any
    }
  },
  {
    deep: true,
    immediate: true
  }
)

// 添加手机号码
const addPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber && phoneNumber.length > 0) {
    if (!state.phoneList.some((item: any) => item.name == phoneNumber)) {
      let line = { name: phoneNumber, default: false }
      state.phoneList.push(line)
    }
    state.phone = ''
    emit('update:value', state.phoneList)
    emit('change', state.phoneList)
  }
}
//
const inputEnterBlur = (val) => {
  addPhoneNumber(val.target.value)
}
// 删除手机号码
const deleteClick = (index) => {
  state.phoneList.splice(index, 1)
  emit('update:value', state.phoneList)
}
</script>

<style lang="less" scoped>
.phone-item {
  display: 100%;
  align-items: center;
  justify-content: space-between;
}
.phone-item-margin {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
</style>
